<template>
  <div class="all">
    <el-skeleton class="width100" :loading="true" animated :throttle="500">
      <template slot="template">
        <!-- 关键词检索  -->
        <div
          class="width99 margin-auto quickbtns f14 margin-top20 formitemlabel"
          v-if="serchkey"
        >
          <span class="pad-left10"></span>
          公司名称 :
          <input
            class="width20 searchinput"
            v-model="input"
            placeholder="  请输入内容"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="mini"
            class="hight30 margin-left10"
            @click="submitForm()"
            >检 索</el-button
          >
          <el-button
            icon="el-icon-refresh"
            class="hight30"
            size="mini"
            @click="resetForm()"
            >重 置</el-button
          >
        </div>
        <p class="flex-between margin-top20 width98 margin-auto">
          <el-button
            type="primary"
            plain
            style="height: 32px; width: 70px"
            @click="toCertifiedbusiness()"
            >新 增</el-button
          >
          <span class="flex">
            <switchcore></switchcore>
            <el-tooltip
              class="item"
              effect="dark"
              content="刷新"
              placement="top"
            >
              <el-button
                size="mini"
                circle
                icon="el-icon-refresh"
                style="height: 28px; margin-top: 5px"
                @click="refresh()"
              />
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="返回"
              placement="top"
            >
              <callback></callback>
            </el-tooltip>
          </span>
        </p>
        <!-- 内容 -->
        <div class="width100 margin-auto backwhite">
          <div class="width100 backwhite">
            <el-table :data="page" class="eltable width98 margin-auto">
              <el-table-column label="企业名称" align="left">
                <template slot-scope="scope"
                  ><span class="bluecolor">{{
                    scope.row.company
                  }}</span></template
                ></el-table-column
              >
              <el-table-column label="用户角色" align="center">
                <template slot-scope="scope"
                  ><span class="bluecolor">{{
                    scope.row.authority
                  }}</span></template
                ></el-table-column
              >
              <el-table-column
                label="实名认证状态"
                align="center"
                prop="status"
              />
              <el-table-column
                label="企业认证时间"
                align="center"
                prop="create_time"
              />
              <el-table-column
                label="操作"
                align="center"
                width="220"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="Setasdefault(scope.row)"
                    >设为默认</el-button
                  >
                  <el-button
                    size="mini"
                    type="text"
                    @click="downloadreport(scope.row)"
                    >取消绑定</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="flex-betweennowrap pad-top20 pad-bot20">
            <span class="bluecolor f14 pad-left10"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>

    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>
 <script>
import { boundEnterprise, boundchange } from "@/api/personal/personal.api";
import BUS from "@/BUS/BUS";
import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      ruleForm: {
        pipo: "",
      },
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progres: { background: "red" },
      progress: "",
      rules: {
        pipo: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
      },
      serchkey: true,
      input: "",
    };
  },
  components: {
    callback,
    switchcore,
  },
  methods: {
    // 新增
    toCertifiedbusiness() {
      this.$router.push({ path: "/Personal-Center/Enterprise-Certification" });
    },
    submitForm() {
      if (this.input != "") {
        // // 获取企业
        boundEnterprise({ _keywords: this.input }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.pagination = true;
            window.sessionStorage.setItem("titlebusiness", this.ruleForm.pipo);
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        // // 获取企业
        boundEnterprise().then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.pagination = true;
            window.sessionStorage.setItem("titlebusiness", this.ruleForm.pipo);
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },

    // 取消绑定
    downloadreport(index) {},
    // 设为默认
    Setasdefault(row) {
      boundchange({ id: row.ent_id }).then((res) => {
        if (res.data.code == 200) {
          BUS.$emit("send", row.company);
          this.refresh();
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 第一个分页
    currentchange(val) {
      window.sessionStorage.setItem("businessval", val);
      if (this.ruleForm.pipo != "" && this.ruleForm.pipo != null) {
        boundEnterprise({
          _keywords: this.ruleForm.pipo,
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        boundEnterprise({
          _keywords: window.sessionStorage.getItem("titlebusiness"),
          page: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    handleSizeChange(val) {
      if (this.ruleForm.pipo != "" && this.ruleForm.pipo != null) {
        boundEnterprise({
          _keywords: this.ruleForm.pipo,
          page: 1,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        boundEnterprise({
          _keywords: window.sessionStorage.getItem("titlebusiness"),
          page: 1,
          limit: val,
        }).then((res) => {
          if (res.data.code == 200) {
            this.page = res.data.data.data;
            this.page.forEach((i) => {
              if (i.authority == 1) {
                i.authority = "管理员";
              }
              if (i.authority == 2) {
                i.authority = "访客";
              }
              if (i.status == 1) {
                i.status = "未实名认证";
              } else if (i.status == 2) {
                i.status = "实名认证中";
              } else {
                i.status = "已实名认证";
              }
            });
            this.total = res.data.data.total;
            this.per_page = res.data.data.per_page;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      }
    },
    // input重 置
    resetForm() {
      this.input = null;
      // // 获取企业
      boundEnterprise().then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.pagination = true;
          window.sessionStorage.setItem("titlebusiness", this.ruleForm.pipo);
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      boundEnterprise({
        _keywords: window.sessionStorage.getItem("titlebusiness"),
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.page.forEach((i) => {
            if (i.authority == 1) {
              i.authority = "管理员";
            }
            if (i.authority == 2) {
              i.authority = "访客";
            }
            if (i.status == 1) {
              i.status = "未实名认证";
            } else if (i.status == 2) {
              i.status = "实名认证中";
            } else {
              i.status = "已实名认证";
            }
          });
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("businessval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("businessval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("businessval")
      );
    }

    boundEnterprise({
      _keywords: window.sessionStorage.getItem("titlebusiness"),
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.page.forEach((i) => {
          if (i.authority == 1) {
            i.authority = "管理员";
          }
          if (i.authority == 2) {
            i.authority = "访客";
          }
          if (i.status == 1) {
            i.status = "未实名认证";
          } else if (i.status == 2) {
            i.status = "实名认证中";
          } else {
            i.status = "已实名认证";
          }
        });
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.all-title {
  height: 56px;
  line-height: 56px;
}
.patenbtn {
  background: #678feb;
  color: #f9f9f9;
  padding: 2px 10px 2px 10px;
}
.Tablename {
  background: #dfdfdf;
  color: #b0b0b0;
}
.Tableconts {
  background: #efefef;
  border-bottom: 1px solid #efefef;
}
.Tablecont {
  border-bottom: 1px solid #efefef;
}
.editor >>> .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
.progress {
  height: 10px;
}
.addproject {
  width: 100px;
  color: white;
  background: #0039bf;
  border-radius: 5px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 13px;
}
</style>